import { j as p } from "../_virtual/jsx-runtime.js";
import { c as d } from "../_virtual/compiler-runtime.js";
import { createContext as x } from "react";
import { getLocaleFromCode as g } from "./locale-map.js";
import { enUS as v } from "../bundled_deps/.pnpm/date-fns@4.1.0/bundled_deps/date-fns/locale/en-US.js";
const u = (l) => String(l), f = x({
  t: u,
  locale: v
});
f.displayName = "SurgeContext";
function E(l) {
  const t = d.c(8), {
    children: n,
    t: a,
    locale: m
  } = l, i = a === void 0 ? u : a, c = m === void 0 ? "en-us" : m;
  let e;
  t[0] !== c ? (e = g(c), t[0] = c, t[1] = e) : e = t[1];
  const s = e;
  let o;
  t[2] !== s || t[3] !== i ? (o = {
    t: i,
    locale: s
  }, t[2] = s, t[3] = i, t[4] = o) : o = t[4];
  let r;
  return t[5] !== n || t[6] !== o ? (r = /* @__PURE__ */ p.jsx(f, { value: o, children: n }), t[5] = n, t[6] = o, t[7] = r) : r = t[7], r;
}
export {
  f as SurgeLocalizationContext,
  E as SurgeLocalizationProvider,
  u as defaultTranslationFunction
};
